module.exports = __webpack_public_path__ + "static/3-b2fa5642ec4f1046717c96afef0b999f.jpg";